<button
  mat-raised-button
  color="primary"
  [matMenuTriggerFor]="menu"
  [disabled]="disabled"
>
  <mat-icon aria-label="File">{{ iconName }}</mat-icon>
  {{ title | translate }}
</button>
<mat-menu #menu="matMenu">
  <form [formGroup]="exportTypeForm" class="menu-item" class="flexColumn">
    <section (click)="$event.stopPropagation()" class="flexColumn">
      <mat-checkbox color="primary" formControlName="consignmentNote">
        Lettres de voiture
      </mat-checkbox>
      <mat-checkbox color="primary" formControlName="excel">
        Détails missions
      </mat-checkbox>
      <mat-checkbox color="primary" formControlName="photos">
        Photos
      </mat-checkbox>
      <mat-checkbox color="primary" formControlName="documents">
        Documents des missions
      </mat-checkbox>
      <mat-checkbox color="primary" formControlName="roadmap">
        Feuille de route
      </mat-checkbox>
      <mat-checkbox color="primary" formControlName="all">
        Tout télécharger
      </mat-checkbox>
    </section>

    <button
      mat-raised-button
      color="primary"
      [disabled]="!canExport()"
      (click)="onExportClicked()"
    >
      Exporter
    </button>
  </form>
</mat-menu>
